import React from "react";
import styled from "styled-components";

const HalfHeightDiv = styled.div`
  height: 70%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-shrink: 0;
`;

const HalfHeightBlueDiv = styled(HalfHeightDiv)`
  height: 30%;
  background: #7af9b7;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  flex-shrink: 0;
  overflow: hidden;
`;

const HalfHeightDarkDiv = styled(HalfHeightBlueDiv)`
  height: 50%;
  background: #7af9b7;
`;

const HalfHeightLightDiv = styled(HalfHeightDiv)`
  height: 50%;
`;

function HalfHeight({ blue, dark, light, children, ...rest }) {
  return dark ? (
    <HalfHeightDarkDiv {...rest}>{children}</HalfHeightDarkDiv>
  ) : blue ? (
    <HalfHeightBlueDiv {...rest}>{children}</HalfHeightBlueDiv>
  ) : light ? (
    <HalfHeightLightDiv {...rest}>{children}</HalfHeightLightDiv>
  ) : (
    <HalfHeightDiv {...rest}>{children}</HalfHeightDiv>
  );
}

export default HalfHeight;
